(function() {
  'use strict';

  // US states + DC + territories (for form dropdown)
  var US_STATES = [
    ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
    ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],
    ['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],
    ['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],
    ['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],
    ['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],
    ['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],
    ['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],
    ['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],
    ['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],
    ['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],
    ['AS','American Samoa'],['GU','Guam'],['MP','Northern Mariana Islands'],
    ['PR','Puerto Rico'],['VI','U.S. Virgin Islands']
  ];

  // ── Read address data from Liquid-rendered JSON blob (no fetch) ──
  var addrData = null;
  var dataEl = document.getElementById('addr-data');
  if (dataEl) {
    try { addrData = JSON.parse(dataEl.textContent); } catch (e) { console.error('addr-data parse error', e); }
  }

  // ── Populate state dropdown ─────────────────────────────────
  function populateStateDropdown() {
    var sel = document.getElementById('addr-province');
    if (!sel) return;
    sel.innerHTML = '<option value="">Select state</option>';
    for (var i = 0; i < US_STATES.length; i++) {
      var opt = document.createElement('option');
      opt.value = US_STATES[i][0];
      opt.textContent = US_STATES[i][1];
      sel.appendChild(opt);
    }
  }

  populateStateDropdown();

  // ── Show toast from URL param after page reload ─────────────
  (function() {
    var params = new URLSearchParams(window.location.search);
    var msg = params.get('_msg');
    if (msg) {
      var type = params.get('_type') || 'success';
      if (typeof __acctToast === 'function') __acctToast(msg, type);
      params.delete('_msg');
      params.delete('_type');
      var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      history.replaceState(null, '', clean);
    }
  })();

  // ── Google Places Autocomplete ──────────────────────────────
  var placesInitialized = false;
  function initPlacesAutocomplete() {
    if (placesInitialized) return;
    var addr1 = document.getElementById('addr-address1');
    if (!addr1) return;
    // Google script loads async — poll briefly if not ready yet
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      var attempts = 0;
      var poll = setInterval(function() {
        attempts++;
        if (typeof google !== 'undefined' && google.maps && google.maps.places) {
          clearInterval(poll);
          initPlacesAutocomplete();
        } else if (attempts > 20) {
          clearInterval(poll);
        }
      }, 250);
      return;
    }

    placesInitialized = true;
    var autocomplete = new google.maps.places.Autocomplete(addr1, { types: ['address'] });

    var usBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(24.396308, -125.0),
      new google.maps.LatLng(49.384358, -66.93457)
    );
    autocomplete.setBounds(usBounds);

    autocomplete.addListener('place_changed', function() {
      var place = autocomplete.getPlace();
      if (!place || !place.address_components) return;

      var streetNumber = '', route = '', city = '', stateShort = '', zip = '';
      place.address_components.forEach(function(c) {
        var t = c.types;
        if (t.indexOf('street_number') !== -1)               streetNumber = c.long_name;
        else if (t.indexOf('route') !== -1)                   route = c.long_name;
        else if (t.indexOf('locality') !== -1)                city = c.long_name;
        else if (t.indexOf('sublocality_level_1') !== -1 && !city) city = c.long_name;
        else if (t.indexOf('administrative_area_level_1') !== -1) stateShort = c.short_name;
        else if (t.indexOf('postal_code') !== -1)             zip = c.long_name;
      });

      addr1.value = (streetNumber ? streetNumber + ' ' : '') + route;
      var cityEl = document.getElementById('addr-city');
      if (cityEl) cityEl.value = city;
      var stateEl = document.getElementById('addr-province');
      if (stateEl && stateShort) {
        var opt = stateEl.querySelector('option[value="' + stateShort + '"]');
        if (opt) stateEl.value = stateShort;
      }
      var zipEl = document.getElementById('addr-zip');
      if (zipEl) zipEl.value = zip;
    });
  }

  // ── Form management ─────────────────────────────────────────
  window.__addrShowForm = function(title) {
    document.getElementById('addr-form').reset();
    document.getElementById('addr-form-id').value = '';
    document.getElementById('addr-form-type').value = 'personal';
    document.getElementById('addr-form-location-id').value = '';
    document.getElementById('addr-form-title').textContent = title || 'Add address';
    document.getElementById('addr-form-wrapper').style.display = '';
    document.body.style.overflow = 'hidden';
    initPlacesAutocomplete();
  };

  window.__addrHideForm = function() {
    document.getElementById('addr-form-wrapper').style.display = 'none';
    document.body.style.overflow = '';
  };

  window.__addrEditPersonal = function(id) {
    if (!addrData) return;
    var addrs = addrData.personalAddresses || [];
    var a = null;
    for (var i = 0; i < addrs.length; i++) {
      if (addrs[i].id === id) { a = addrs[i]; break; }
    }
    if (!a) return;

    document.getElementById('addr-form-id').value = a.id;
    document.getElementById('addr-form-type').value = 'personal';
    document.getElementById('addr-form-location-id').value = '';
    document.getElementById('addr-firstName').value = a.firstName;
    document.getElementById('addr-lastName').value = a.lastName;
    document.getElementById('addr-company').value = a.company;
    document.getElementById('addr-address1').value = a.address1;
    document.getElementById('addr-address2').value = a.address2;
    document.getElementById('addr-city').value = a.city;
    document.getElementById('addr-province').value = a.provinceCode;
    document.getElementById('addr-zip').value = a.zip;
    document.getElementById('addr-phone').value = a.phone;
    document.getElementById('addr-form-title').textContent = 'Edit address';
    document.getElementById('addr-form-wrapper').style.display = '';
    document.body.style.overflow = 'hidden';
    initPlacesAutocomplete();
  };

  window.__addrEditCompany = function(locationId, type) {
    if (!addrData) return;
    var locs = addrData.companyLocations || [];
    var loc = null;
    for (var i = 0; i < locs.length; i++) {
      if (locs[i].id === locationId) { loc = locs[i]; break; }
    }
    if (!loc) return;

    var a = loc.shippingAddress || {};

    document.getElementById('addr-form-id').value = '';
    document.getElementById('addr-form-type').value = 'company';
    document.getElementById('addr-form-location-id').value = locationId;
    document.getElementById('addr-firstName').value = a.firstName || '';
    document.getElementById('addr-lastName').value = a.lastName || '';
    document.getElementById('addr-company').value = a.company || '';
    document.getElementById('addr-address1').value = a.address1 || '';
    document.getElementById('addr-address2').value = a.address2 || '';
    document.getElementById('addr-city').value = a.city || '';
    document.getElementById('addr-province').value = a.provinceCode || '';
    document.getElementById('addr-zip').value = a.zip || '';
    document.getElementById('addr-phone').value = a.phone || '';
    document.getElementById('addr-form-title').textContent = 'Edit company ' + type + ' address';

    document.getElementById('addr-form-id').dataset.addressType = type;
    document.getElementById('addr-form-wrapper').style.display = '';
    document.body.style.overflow = 'hidden';
    initPlacesAutocomplete();
  };

  // ── Reload page after mutation (Liquid re-renders fresh data) ──
  function reloadWithToast(msg) {
    var sep = window.location.pathname.indexOf('?') === -1 ? '?' : '&';
    window.location.href = window.location.pathname + '?_msg=' + encodeURIComponent(msg);
  }

  // ── Save address (POST only) ────────────────────────────────
  window.__addrSave = function(e) {
    e.preventDefault();

    var form = document.getElementById('addr-form');
    if (!form.checkValidity()) { form.reportValidity(); return false; }

    var btn = document.getElementById('addr-save-btn');
    var txt = document.getElementById('addr-save-text');
    var spin = document.getElementById('addr-save-spinner');
    btn.disabled = true;
    txt.textContent = 'Saving...';
    spin.style.display = '';

    var formType = document.getElementById('addr-form-type').value;
    var payload = {
      firstName: document.getElementById('addr-firstName').value.trim(),
      lastName: document.getElementById('addr-lastName').value.trim(),
      company: document.getElementById('addr-company').value.trim(),
      address1: document.getElementById('addr-address1').value.trim(),
      address2: document.getElementById('addr-address2').value.trim(),
      city: document.getElementById('addr-city').value.trim(),
      provinceCode: document.getElementById('addr-province').value,
      zip: document.getElementById('addr-zip').value.trim(),
      phone: document.getElementById('addr-phone').value.trim()
    };

    var url;
    if (formType === 'company') {
      var locId = document.getElementById('addr-form-location-id').value;
      var addrType = document.getElementById('addr-form-id').dataset.addressType || 'shipping';
      payload.addressType = addrType;
      url = '/apps/purchase-history/addresses/company-location/' + encodeURIComponent(locId);
    } else {
      var addrId = document.getElementById('addr-form-id').value;
      if (addrId) payload.id = parseInt(addrId, 10);
      url = '/apps/purchase-history/addresses/personal';
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.error) {
        btn.disabled = false;
        txt.textContent = 'Save address';
        spin.style.display = 'none';
        __acctToast(data.error, 'error');
      } else {
        reloadWithToast('Address saved.');
      }
    })
    .catch(function(err) {
      btn.disabled = false;
      txt.textContent = 'Save address';
      spin.style.display = 'none';
      __acctToast('Something went wrong. Please try again.', 'error');
      console.error('Address save error:', err);
    });

    return false;
  };

  // ── Delete address (POST only) ──────────────────────────────
  window.__addrDelete = function(id) {
    if (!confirm('Delete this address?')) return;

    fetch('/apps/purchase-history/addresses/personal/delete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.error) {
        __acctToast(data.error, 'error');
      } else {
        reloadWithToast('Address deleted.');
      }
    })
    .catch(function(err) {
      __acctToast('Could not delete address.', 'error');
      console.error('Address delete error:', err);
    });
  };

  // ── Set default (POST only) ─────────────────────────────────
  window.__addrSetDefault = function(id) {
    fetch('/apps/purchase-history/addresses/personal/default', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.error) {
        __acctToast(data.error, 'error');
      } else {
        reloadWithToast('Default address updated.');
      }
    })
    .catch(function(err) {
      __acctToast('Could not set default address.', 'error');
      console.error('Address default error:', err);
    });
  };

})();
